import clsx from 'clsx';
import { Popover } from 'radix-ui';
import type { ReactNode } from 'react';

/* -------------------------------------------------------------------------- */
/*                                    Types                                   */
/* -------------------------------------------------------------------------- */

type LayerControlPopoverProps = {
  /** The button/element that triggers the popover */
  trigger: ReactNode;
  /** Heading rendered in the panel header */
  title: ReactNode;
  /** Panel body content — typically LayerItem rows */
  children: ReactNode;
  /** Additional CSS classes for the popover body container */
  className?: string;
};

/* -------------------------------------------------------------------------- */
/*                               Main component                               */
/* -------------------------------------------------------------------------- */

const LayerControlPopover = ({ trigger, title, children, className }: LayerControlPopoverProps) => {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>{trigger}</Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className="w-70 rounded-lg border border-border/20 bg-popover text-popover-foreground shadow-md"
          align="start"
          side="left"
          sideOffset={12}
        >
          {/* Header */}
          <div className="flex items-center justify-between rounded-t-lg bg-muted px-4 py-3">
            <h3 className="font-medium text-sm">{title}</h3>
          </div>
          {/* Body */}
          <div className={clsx('flex flex-col divide-y divide-border/40 px-4', className)}>{children}</div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
LayerControlPopover.displayName = 'LayerControlPopover';

/* -------------------------------------------------------------------------- */
/*                                   Exports                                  */
/* -------------------------------------------------------------------------- */

export { LayerControlPopover };
